export interface AreaDataSlice {
  areaIdToSignatureData: { [areaId: string]: string };
  areaIdToTextContent: { [areaId: string]: string };
  areaIdToCheckboxData: { [areaId: string]: boolean };
  initializeAreaSignatures: (areaIds: string[]) => void;
  initializeTextContent: (areaIds: string[]) => void;
  initializeCheckboxData: (areaIds: string[]) => void;
  setAreaIdToSignatureData: (areaId: string, signatureData: string) => void;
  setAreaTextContent: (areaId: string, text: string) => void;
  setAreaCheckboxData: (areaId: string, checked: boolean) => void;
  setAllSignaturesData: (signatureData: string) => void;
}

type Set = (partial: Partial<AreaDataSlice> | ((state: AreaDataSlice) => Partial<AreaDataSlice>)) => void;

export const createAreaDataSlice = (set: Set): AreaDataSlice => ({
  areaIdToTextContent: {},
  areaIdToSignatureData: {},
  areaIdToCheckboxData: {},
  initializeAreaSignatures: areaIds => set({ areaIdToSignatureData: Object.fromEntries(areaIds.map(id => [id, ''])) }),
  initializeTextContent: areaIds => set({ areaIdToTextContent: Object.fromEntries(areaIds.map(id => [id, ''])) }),
  initializeCheckboxData: areaIds => set({ areaIdToCheckboxData: Object.fromEntries(areaIds.map(id => [id, false])) }),
  setAllSignaturesData: signatureData => set(state => ({
    areaIdToSignatureData: Object.fromEntries(Object.entries(state.areaIdToSignatureData)
      .map(([areaId]) => [areaId, signatureData]))
  })),
  setAreaIdToSignatureData: (areaId, signatureData) => set(state => ({
    areaIdToSignatureData: { ...state.areaIdToSignatureData, [areaId]: signatureData }
  })),
  setAreaCheckboxData: (areaId, checked) => set(state => ({
    areaIdToCheckboxData: { ...state.areaIdToCheckboxData, [areaId]: checked }
  })),
  setAreaTextContent: (areaId, text) => set(state => ({
    areaIdToTextContent: { ...state.areaIdToTextContent, [areaId]: text }
  })),
});
